// Kept out of the component file so that module exports components only.

/** Percent of the price that goes on the plate, or null when it can't be told. */
export function foodCostPercent(
  costPerPortion: number | null | undefined,
  price: number | null,
): number | null {
  if (costPerPortion == null || price == null || !(price > 0)) return null;
  return (costPerPortion / price) * 100;
}
